import { useState, useEffect } from 'react'

export const useWindowSize = (dependency?: boolean | string) => {
  const isClient = typeof window === 'object'

  const getSize = () => {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    }
  }

  const [windowSize, setWindowSize] = useState(getSize)

  useEffect(() => {
    if (isClient) {
      const handleResize = () => {
        setWindowSize(getSize())
      }

      window.addEventListener('resize', handleResize)
    }
  }, []) // eslint-disable-line

  useEffect(() => {
    setWindowSize(getSize())
  }, [dependency]) // eslint-disable-line

  return windowSize
}
